import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { useIsLoggedIn } from 'hooks/use-is-logged-in';
import { UseQueryOptions, UseQueryResult } from 'react-query';

const endpoint = 'ums/v1/crm/management/brands/contacts';
export const getContactDetailsByIdEndpointIdentifier = endpoint;

export type IContactDetailsById = {
  id: number;
  contactName: string;
  designation?: string;
  phoneNumber?: string;
  email?: string;
  isVerified: boolean;
  createdAt: string;
  updatedAt: string;
  brand: {
    id: number;
    name: string;
    image?: string;
  };
};

type TData = IContactDetailsById;
type TError = AxiosError;
type TQueryKey = [typeof endpoint, number];

type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;
type ReturnType = UseQueryResult<TData, TError>;

export function useGetContactDetailsByIdApi(id: number, options?: Options): ReturnType {
  const isLoggedIn = useIsLoggedIn();

  const queryKey: TQueryKey = [endpoint, id];

  const queryFn = async () => {
    const { data } = await http.get(`${endpoint}/${id}`);
    return data;
  };

  return useQueryWrapper(queryKey, queryFn, {
    enabled: isLoggedIn && !!id,
    ...options,
  });
}
